import { BUILD_PROPERTIES } from '@/editor/constant/buildProperties';
import { globalStores } from '@/editor/stores';
import { EEntityType } from '@/editor/types';
import {
  EParamGroupLabel,
  EParamLabel,
  EParamType,
  EParamUnit,
  EParamsKeys,
  IEditParams
} from '@/editor/types/editParamType';
import { IAssemblyData } from '@/editor/data/assembly/assembly';

export function getAssemblyParamInfo(assemblyData: IAssemblyData) {
  const paramDatas: IEditParams = {
    id: assemblyData.id,
    type: EEntityType.Assembly,
    title: EParamGroupLabel.FURNITURE_SETS,
    group: [
      {
        id: EParamGroupLabel.SIZE,
        label: EParamGroupLabel.SIZE,
        fields: [EParamsKeys.width, EParamsKeys.length, EParamsKeys.height, EParamsKeys.rotation, EParamsKeys.offGround]
      }
    ],
    values: {
      [EParamsKeys.length]: Math.round(assemblyData.thickness),
      [EParamsKeys.width]: Math.round(assemblyData.width),
      [EParamsKeys.height]: Math.round(assemblyData.height),
      [EParamsKeys.rotation]: Math.round((assemblyData.rotation / Math.PI) * 180),
      [EParamsKeys.offGround]: Math.round(assemblyData.offGround)
    },
    fields: {
      [EParamsKeys.width]: {
        type: EParamType.NUMBER,
        unit: EParamUnit.MM,
        label: EParamLabel.MODEL_WIDTH,
        settings: {
          disabled: true
        }
      },
      [EParamsKeys.length]: {
        label: EParamLabel.MODEL_LENGTH,
        type: EParamType.NUMBER,
        unit: EParamUnit.MM,
        settings: {
          disabled: true
        }
      },
      [EParamsKeys.height]: {
        type: EParamType.NUMBER,
        label: EParamLabel.MODEL_HEIGHT,
        unit: EParamUnit.MM,
        settings: {
          disabled: true
        }
      },
      [EParamsKeys.rotation]: {
        type: EParamType.NUMBER,
        label: EParamLabel.PLANE_ROTATE,
        unit: EParamUnit.ANGLE,
        settings: {
          min: BUILD_PROPERTIES.ROTATION_ANGLE_RANGE[0],
          max: BUILD_PROPERTIES.ROTATION_ANGLE_RANGE[1],
          readonly: false
        }
      },
      [EParamsKeys.offGround]: {
        type: EParamType.NUMBER,
        label: EParamLabel.MODEL_OFFGROUND,
        unit: EParamUnit.MM,
        settings: {
          readonly: false,
          max: globalStores.paramStore.layerHeight,
          min: 0
        }
      }
    }
  };

  return paramDatas;
}
